module.exports = __webpack_public_path__ + "img/rsz_terasa-min.64d70a46.jpg";